import { useCallback, useState } from 'react';
import { TechnicalPlanTable } from '@bulthaup/api/db';
import { electricityOptionVariants } from '@bulthaup/api/routers/documents/technical-plan/-technical-plan-table-constants';
import {
  Button,
  Checkbox,
  Grid,
  Group,
  Modal,
  Radio,
  Stack,
  Text,
  Title,
  Tooltip,
} from '@mantine/core';
import { useForm } from '@mantine/form';

export const plumbingTooltips: Record<string, string> = {
  ZE1: "zone implantation plomberie sous evier AR ec/ef vannes d'arret 1/4 de tour.Evacuation evier. AR eau froide robinet 1/4 de tour sortie verticale vers le bas pour aqua stop.1 Vidange siphonee.",
  ZE2: "zone implantation plomberie sous evier AR ec/ef vannes d'arret 1/4 de tour.Evacuation evier.2 AR eau froide robinet 1/4 de tour sortie verticale vers le bas pour aqua stop.Vidange double siphonée. ",
  ZE: "ZONE D'IMPLANTATION PLOMBERIE DANS SOUS EVIER ARRIVEE EC/EF AVEC VANNES D'ARRET 1/4 DE TOUR POUR ALIMENTATION EVIER. EVACUATION EVIER.",
  AM: 'ARRIVEE EAU FROIDE AVEC ROBINET 1/4 DE TOUR SORTIE VERTICALE VERS LE BAS POUR MACHINE A LAVER AVEC AQUA-STOP DE 20 CM.',
  VD: 'VIDANGE SIPHONEE POUR APPAREIL.',
  V2: 'VIDANGE DOUBLE SIPHONEE POUR APPAREIL.',
  AP: "ARRIVEE D 'EAU FROIDE VERS LE BAS POUR AQUA-STOP 20 CM. PROLONGEE, DEPUIS LE ROBINET 1/4 DE TOUR,",
  CG: 'ARRIVEE POUR ALIMENTATION GAZ ET ROBINET DE BARRAGE EN ATTENTE SUR JOUE DU MEUBLE.',
  AG: 'ARRIVEE  GAZ+ROBINET DE BARRAGE.',
  GZ: 'PROLONGEMENT GAZ EN DUR ENTRE ROBINET ET PLAQUE.',
  ZFV: "ARRIVEE EAU FROIDE POUR FOUR VAPEUR AVEC VANNE D'ARRET 1/4 DE TOUR, VIDANGE SIPHONEE POUR APPAREIL.",
  Z1M: 'ARRIVEE EAU FROIDE AVEC ROBINET 1/4 DE TOUR, SORTIE VERTICALE VERS LE BAS POUR MACHINE A LAVER AVEC AQUA-STOP 20 CM. VIDANGE SIPHONEE DE LA MACHINE A LAVER.',
  Z2M: '2 AR EAU FROIDE AVEC ROBINETS 1/4 DE TOUR, SORTIE VERTICALE VERS LE BAS POUR 2 MACHINES A LAVER AVEC AQUA-STOP 20 CM. VIDANGE DOUBLE SIPHONEE POUR LES MACHINES A LAVER.',
  ZSL: "AR EAU FROIDE AVEC ROBINETS D'ARRET 1/4 DE TOUR SORTIE VERTICALE VERS LE BAS POUR MACHINE A LAVER AVEC AQUA-,STOP 20 CM. VIDANGE DOUBLE SIPHONEE POUR LES MACHINES A LAVER.",
  AR: "ARRIVEE ALIMENTATION EAU FROIDE AVEC VANNE D'ARRET 1/4 DE TOUR SORTIE VERTICALE POUR REFRIGERATEUR.",
};

export const electricityTooltips: Record<string, string> = {
  RF: 'PRISE POUR FROID',
  CV: 'PRISE POUR CAVE A VIN',
  FO: 'PRISE POUR FOUR',
  GF: 'BOITIER DE RACCORDEMENT POUR GROS FOUR',
  HT: 'PRISE POUR HOTTE',
  LV: 'PRISE POUR LAVE VAISSELLE',
  PE: 'BOITIER DE RACCORDEMENT + SORTIE DE FILS POUR PLAQUE ELECTRIQUE',
  MO: 'PRISE  POUR MICRO-ONDES',
  PM: '1 PRISE DE COURANT POUR PETIT APPAREIL',
  PC1: "1 PRISE POUR CREDENCE avec boitier cloison seche non scellé et adapté en fonction de l'appareillage, POUR UNE CREDENCE BULTHAUP",
  PC2: "1 DOUBLE PRISE POUR CREDENCE avec boitier cloison seche non scellé et adapté en fonction de l'appareillage, POUR UNE CREDENCE BULTHAUP",
  PC3: '',
  B1: '1 SORTIE DE FILS + DOMINO + 1 BOITIER CLOISON SECHE NON SCELLE AVEC RESERVATION DE 5CM,     PRISE DE CREDENCE et CREDENCE FOURNIE par bulthaup,',
  B2: '2 SORTIES DE FILS + DOMINOS + 2 BOITIERS CLOISON SECHE NON SCELLES AVEC RESERVATION DE 5CM,     PRISES DE CREDENCE et CREDENCE FOURNIE par bulthaup,',
  B3: '',
  CC: '',
  AC: '',
  VA: '',
  PA: '1 PRISE EN APPLIQUE RELIEES A (PS) Prévoir 3 M de fils supplémentaires.',
  P1: '1 PRISE POUR ALIMENTATION PRISE(s) CREDENCE bulthaup',
  PN: '1 PRISE DE CREDENCE',
  SF: '1 SORTIE DE FILS + DOMINO',
  LL: 'PRISE POUR LAVE-LINGE',
  SL: 'PRISE POUR SECHE LINGE',
  FV: 'PRISE POUR FOUR VAPEUR',
  FC: 'PRISE POUR FOUR COMPACT',
  PG: 'PRISE POUR ALLUMAGE PLAQUE GAZ',
  TC: 'CABLE DE RACCORDEMENT RO2V 5G 2.5 Relier au moteur dans les combles',
  S1: '1 PRISE POUR ECLAIRAGE COMMANDEE PAR INTERRUPTEUR bulthaup',
  S2: '1 PRISE POUR ECLAIRAGE RELIEES A (S1) PAR PONTAGE ENCASTRE',
  F1: "1 PRISE POUR ECLAIRAGE COMMANDEE PAR INTERRUPTEUR A L'ENTREE OU PAR (IT)",
  F2: '1 PRISE POUR ECLAIRAGE RELIEES A (F1) PAR PONTAGE ENCASTRE',
  MR: '1 PRISE POUR ALIMENTATION 3 A 6 PRISES DE COURANT FOURNIES PAR BULTHAUP',
  TV: 'PRISE ANTENNE POUR POSTE DE TELEVISION',
  TL: 'PRISE POUR POSTE DE TELEPHONE',
  SE: 'SPOT ENCASTRE DANS LA RETOMBEE DE PALFOND AU-DESSUS DES MEUBLES, HAUTEUR SOUS RETOMBEE = ( A DET cm ) AU POINT LE PLUS HAUT DU SOL FINI',
  PEi: 'BOITIER DE RACCORDEMENT + SORTIE DE FILS POUR PLAQUE ELECTRIQUE POUR ILOT',
  HTi: 'PRISE POUR HOTTE POUR ILOT',
  SFi: '1 SORTIE DE FILS + DOMINO POUR ILOT',
  LVi: 'PRISE POUR LAVE VAISSELLE POUR ILOT',
  RFi: 'PRISE POUR FROID POUR ILOT',
  FOi: 'PRISE POUR FOUR POUR ILOT',
  MOi: 'PRISE POUR MICRO-ONDES POUR ILOT',
  E1: 'ECLAIRAGE RELIES PAR LE MEME INTERRUPTEUR',
  E2: 'ECLAIRAGE RELIES PAR LE MEME INTERRUPTEUR',
  SG: 'SORTIE DE GAINE ELECTRIQUE DIAMETRE 20',
  EG: 'ENTREE DE GAINE ELECTRIQUE DIAMETRE 20',
  TS: 'PRISE TIROIR SOUS VIDE',
  CM: "CLAPET ANTI-REFOULEMENT MOTORISE POUR UNE ENTREE D'AIR DANS LA CUISINE COMMANDE PAR INTERRUPTEUR (I1)",
  I1: "INTERRUPTEUR COMMANDANT L 'OUVERTURE DE (CM) ET MISE SOUS TENSION DE  (HT1)",
  HT1: 'PRISE POUR HOTTE COMMANDEE PAR INTERRUPTEUR (I1)',
  PS: 'PRISE',
  IT: 'INTERRUPTEUR MURAL',
};

export const masonryTooltips: Record<string, string> = {
  CL: 'CLOISON A CRÉER',
  FP: 'FAUX PLAFOND A CRÉER,',
  CF: 'COFFRAGE A CRÉER. A PEINDRE DE LA COULEUR DU MUR',
  PL: 'PILIER A CRÉER,',
  OC: 'OUVERTURE A CRÉER',
  SB: 'SOCLE EN BETON POUR MACHINE',
  RE: 'RETOMBEE DE PLAFOND AVEC JOINT CREUX A CRÉER APRES LA POSE DES MEUBLES, A PEINDRE DE LA COULEUR DU MUR.',
  PR: 'PANNEAU A CRÉER, SUR TOUTE LA PROFONDEUR A PARTIR DU COFFRAGE (CF)',
  VH_15:
    'EVACUATION DE LA HOTTE FLEXALU AU PLAFOND, DIAMETRE = 15cm NON FOURNI PAR BULTHAUP',
  ZC: 'ZONE D ACCROCHAGE HOTTE,DANS COFFRAGE DE HOTTE FIXEE A LA DALLE',
  VH_18:
    'EVACUATION DE LA HOTTE BULTHAUP FLEXALU AU PLAFOND, DIAMETRE = 18cm NON FOURNI PAR BULTHAUP',
  CH: 'COFFRAGE DE HOTTE FIXEE A LA DALLE AVEC SOUS FACE POUR ENCASTREMENT GROUPE HOTTE',
  FX: "FLEXIBLE ALU RELIE AU MOTEUR SOUS LES COMBLES LE MOTEUR DOIT ETRE PRES D'UN CONDUIT ETANT RELIER A L'EXTERIEUR",
  ZA: "ZONE D 'ACCROCHAGE POUR LA HOTTE",
  GR: 'GRILLE DE VENTILATION  A PEINDRE DE LA COULEUR DU COFFRAGE',
};

export default function TechnicalPlanTableForm({
  technicalPlanTable,
  onSubmit,
}: {
  technicalPlanTable: TechnicalPlanTable | null;
  onSubmit: (values: TechnicalPlanTable) => Promise<void>;
}) {
  const [variantsModalOpened, setVariantsModalOpened] = useState(false);
  const [selectedElectricityOption, setSelectedElectricityOption] = useState<
    string | null
  >(null);
  const [selectedElectricityVariant, setSelectedElectricityVariant] = useState<
    [number, number] | null
  >(null);

  const ElectricityOptions = Object.keys(electricityTooltips);
  const MasonryOptions = Object.keys(masonryTooltips);
  const PlumbingOptions = Object.keys(plumbingTooltips);

  const form = useForm<{
    plumbing: Record<string, boolean>;
    electricity: Record<
      string,
      | {
          powerConsumption: number;
          amperage: number;
        }
      | boolean
    >;
    masonry: Record<string, boolean>;
  }>({
    initialValues: technicalPlanTable || {
      plumbing: PlumbingOptions.reduce(
        (acc, key) => ({ ...acc, [key]: false }),
        {},
      ),
      electricity: ElectricityOptions.reduce(
        (acc, key) => ({ ...acc, [key]: false }),
        {},
      ),
      masonry: MasonryOptions.reduce(
        (acc, key) => ({ ...acc, [key]: false }),
        {},
      ),
    },
  });

  const handleSubmit = useCallback(
    async (values: typeof form.values) => {
      await onSubmit(values);
    },
    [onSubmit],
  );

  const handleElectricityCheckboxChange = useCallback(
    (option: string, checked: boolean) => {
      if (checked && electricityOptionVariants[option]) {
        setSelectedElectricityOption(option);
        setVariantsModalOpened(true);
      } else {
        form.setFieldValue(`electricity.${option}`, checked);
        if (!checked) {
          form.setFieldValue(`electricity.${option}`, false);
        }
      }
    },
    [form],
  );

  const handleVariantSelection = useCallback(() => {
    if (selectedElectricityOption && selectedElectricityVariant) {
      form.setFieldValue(`electricity.${selectedElectricityOption}`, {
        powerConsumption: selectedElectricityVariant[0],
        amperage: selectedElectricityVariant[1],
      });
      setVariantsModalOpened(false);
      setSelectedElectricityOption(null);
      setSelectedElectricityVariant(null);
    }
  }, [selectedElectricityOption, selectedElectricityVariant, form]);

  const handleModalClose = useCallback(() => {
    setVariantsModalOpened(false);
    setSelectedElectricityOption(null);
    setSelectedElectricityVariant(null);
  }, []);

  const renderCheckboxGroup = useCallback(
    (
      title: string,
      options: string[],
      field: keyof typeof form.values,
      columns: number = 1,
    ) => (
      <Stack gap="xs">
        <Title order={4}>{title}</Title>
        <Grid>
          {options
            .sort((a, b) => a.localeCompare(b))
            .map(option => {
              const hasVariants =
                field === 'electricity' && electricityOptionVariants[option];
              const selectedVariant =
                hasVariants && form.values.electricity[option]
                  ? form.values.electricity[option]
                  : undefined;
              const fieldValue = form.values[field][option];
              const isChecked =
                field === 'electricity'
                  ? typeof fieldValue === 'object'
                    ? true
                    : fieldValue === true
                  : fieldValue === true;

              return (
                <Grid.Col key={title + option} span={12 / columns}>
                  <Stack gap={4}>
                    <Tooltip
                      openDelay={500}
                      multiline
                      w={220}
                      withArrow
                      transitionProps={{ duration: 200 }}
                      label={(field === 'plumbing'
                        ? plumbingTooltips[option]
                        : field === 'electricity'
                          ? electricityTooltips[option]
                          : field === 'masonry'
                            ? masonryTooltips[option]
                            : undefined
                      )?.toLowerCase()}
                    >
                      <Checkbox
                        label={option}
                        checked={isChecked}
                        onChange={event => {
                          if (field === 'electricity') {
                            handleElectricityCheckboxChange(
                              option,
                              event.currentTarget.checked,
                            );
                          } else {
                            form.setFieldValue(
                              `${field}.${option}`,
                              event.currentTarget.checked,
                            );
                          }
                        }}
                      />
                    </Tooltip>
                    {selectedVariant && typeof selectedVariant === 'object' && (
                      <Text size="xs" c="dimmed" ml={28}>
                        {selectedVariant.powerConsumption}kW /{' '}
                        {selectedVariant.amperage}A
                      </Text>
                    )}
                  </Stack>
                </Grid.Col>
              );
            })}
        </Grid>
      </Stack>
    ),
    [form.values, handleElectricityCheckboxChange, form.setFieldValue],
  );

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Grid gutter="xl">
        <Grid.Col span={6}>
          <Stack gap="xl">
            {renderCheckboxGroup('PLOMBERIE', PlumbingOptions, 'plumbing', 2)}
            {renderCheckboxGroup('MACONNERIE', MasonryOptions, 'masonry', 2)}
          </Stack>
        </Grid.Col>
        <Grid.Col span={6}>
          {renderCheckboxGroup(
            'ELECTRICITE',
            ElectricityOptions,
            'electricity',
            3,
          )}
        </Grid.Col>
      </Grid>

      <Group justify="center" mt="xl">
        <Button type="submit" size="md">
          OK
        </Button>
      </Group>

      <Modal
        opened={variantsModalOpened}
        onClose={handleModalClose}
        title={`Sélectionner la variante pour ${selectedElectricityOption}`}
        zIndex={1000}
      >
        <Stack gap="md">
          <Text size="sm" c="dimmed">
            Veuillez sélectionner la combinaison puissance/ampérage :
          </Text>

          {selectedElectricityOption &&
            electricityOptionVariants[selectedElectricityOption] && (
              <Radio.Group
                value={
                  selectedElectricityVariant
                    ? `${selectedElectricityVariant[0]}-${selectedElectricityVariant[1]}`
                    : ''
                }
                onChange={value => {
                  const [power, amperage] = value.split('-').map(Number);
                  setSelectedElectricityVariant([power, amperage]);
                }}
              >
                <Stack gap="xs">
                  {electricityOptionVariants[selectedElectricityOption].map(
                    ([power, amperage]) => (
                      <Radio
                        key={`${power}-${amperage}`}
                        value={`${power}-${amperage}`}
                        label={`${power}kW / ${amperage}A`}
                      />
                    ),
                  )}
                </Stack>
              </Radio.Group>
            )}

          <Group justify="flex-end" mt="md">
            <Button variant="outline" onClick={handleModalClose}>
              Annuler
            </Button>
            <Button
              onClick={handleVariantSelection}
              disabled={!selectedElectricityVariant}
            >
              Confirmer
            </Button>
          </Group>
        </Stack>
      </Modal>
    </form>
  );
}
